<template>
  <div class="row">
      <div class="col-md-12">
         <div class='form-group col-md-12'>
            <a href='#' @click="showNewsForm=!showNewsForm" >Добавить новость</a>
            <br>
            <div v-show="showNewsForm">
              <label>Заголовок новости</label>
              <input class='form-control' type='text' v-model="newNewsStruct.title" >
              <label>Тип новости</label>
              <select class='form-control' v-model="newNewsStruct.type">
                <option value="1">Образование</option>
                <option value="2">Культура</option>
              </select>
              <label>Текст новости</label>
              <textarea class='form-control' v-model="newNewsStruct.text"></textarea>
              <br>
              <label>Продублировать новость на емаил</label>
              <input type='checkbox' v-model="newNewsStruct.replyemail">
              <br>
              <button class='btn btn-success' @click="sendNewNews();">Добавить</button>
            </div>
         </div>


        <hr>
        <h3>Новости образования</h3>
        <div class='form-group col-md-12'>
          <div v-for="(edu,id) in jsonNews.edu" :key="id">
            <a href='#' @click="edu.show=!edu.show">{{edu.date}} - {{edu.title}}</a> <span class="badge badge-danger" @click='deletenews(edu.id)' style='cursor:pointer;'>Удалить</span>
            <br>
            <div v-show="edu.show">
              <label>Дата</label>
              <input class='form-control' type='text' v-model="edu.date">
              <label>Заголовок новости</label>
              <input class='form-control' type='text' v-model="edu.title">
              <label>Тип новости</label>
              <select class='form-control' v-model="edu.type">
                <option value="1">Образование</option>
                <option value="2">Культура</option>
              </select>
              <label>Текст новости</label>
              <textarea class='form-control' v-model="edu.text"></textarea>
              <br>
              <button class='btn btn-success' @click='sendSaveNews();'>Сохранить</button>
            </div>
          </div>
        </div>
        <hr>
        <h3>Новости культуры</h3>
        <div class='form-group col-md-12'>
          <div v-for="(edu,id) in jsonNews.culture" :key="id">
            <a href='#' @click="edu.show=!edu.show">{{edu.date}} - {{edu.title}} </a> <span class="badge badge-danger" @click='deletenews(edu.id)' style='cursor:pointer;'>Удалить</span>
            <br>
            <div v-show="edu.show">
              <label>Дата</label>
              <input class='form-control' type='text' v-model="edu.date">
              <label>Заголовок новости</label>
              <input class='form-control' type='text' v-model="edu.title">
              <label>Тип новости</label>
              <select class='form-control' v-model="edu.type">
                <option value="1">Образование</option>
                <option value="2">Культура</option>
              </select>
              <label>Текст новости</label>
              <textarea class='form-control' v-model="edu.text"></textarea>
              <br>
              <button class='btn btn-success'>Сохранить</button>
            </div>
          </div>
        </div>
      </div>      
  </div>
</template>

<script>
import axios from 'axios';
import NProgress from 'nprogress';

export default {
  methods:{
    deletenews: function(id){
      NProgress.start();
      axios({
        withCredentials: true,
        url: 'http://eduqa.egechita.ru/back/deletenews/'+id
      }).then(Response => {
        this.getNews();
        NProgress.done();
      });
    },
    sendSaveNews: function(){
      NProgress.start();
      axios({
        withCredentials: true,
        url: 'http://eduqa.egechita.ru/back/modnews',
        method: "POST",
        data: this.jsonNews
      }).then(Response => { 
        NProgress.done();
        this.getNews();
       });
      //console.log(this.newNewsStruct);
    },
    getNews: function(){
      NProgress.start();
      axios.get('http://eduqa.egechita.ru/back/news').then((Response) => {
      this.jsonNews = Response.data;
      NProgress.done();
    });
    },
    sendNewNews: function(){
      NProgress.start();
      axios({
        withCredentials: true,
        url: 'http://eduqa.egechita.ru/back/addnews',
        method: "POST",
        data: this.newNewsStruct 
      }).then(Response => { 
        this.newNewsStruct.title = "";
        this.newNewsStruct.type = "";
        this.newNewsStruct.text = "";
        this.replyemail = false;
        NProgress.done();
        this.getNews();
       });
      //console.log(this.newNewsStruct);
    }
  },
  created: function() {
    this.getNews();
  },
 
  data() {
    return {
      jsonNews: "",
      showNewsForm: 0,
      newNewsStruct: {
        title: "",
        type: "",
        text: "",
        replyemail: false
      }
    };
  }
};
</script>

<style>

</style>